import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Amplify, { Analytics } from 'aws-amplify';
import { withAlert } from 'react-alert';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import * as Modal from 'react-modal';
import * as SecretKeys from '../../../ENV.json';
import {
  submitSubUser,
  getAllBusinessSubUsers,
  deleteBusinessSubUser,
} from '../../../Actions/actions';
import 'react-table/react-table.css';
import loader from '../../../images/Spin-1s-107px.gif';

Amplify.configure(SecretKeys.awsUserpool);

Analytics.disable();

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
    width: '60%',
  },
};


class SubuserListAffiliate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      firstname: '',
      lastname: '',
      phone: '',
      password: '',
      errors: {},
      isLoading: false,
      isDelete: false,
      failedLoginMessages: '',
      data: [],
      GetBusinessSubUserList1: [],
      modalIsOpenSubUserDelete: false,
      deleteSubUserid: '',
      loaded: false,
    };
    this.onChange = this.onChange.bind(this);
    this.handleSubUsers = this.handleSubUsers.bind(this);
    this.closeModalSubUserDelete = this.closeModalSubUserDelete.bind(this);
  }

  onChange(e) {
    this.setState({ errors: {}, isLoading: true, failedLoginMessages: '' });
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubUsers(e) {
    e.preventDefault();
    this.props.submitSubUser(this.state);
  }

  componentDidMount() {
    this.props.getAllBusinessSubUsers();
  }

  handleClickOpenDelete = () => {
    const { deleteSubUserid } = this.state;
    const data = {
      id: deleteSubUserid,
    };
    this.setState({ isDelete: true, modalIsOpenSubUserDelete: false, loaded: true });
    this.props.deleteBusinessSubUser(data);
  }

  componentWillReceiveProps(nextProps) {
    const settleRecord = nextProps.data.GetBusinessSubUserList;
    // let deleteRecord = nextProps.data.GetDeletedBusinessSubUser;
    // console.log('settleRecord',settleRecord);
    if (this.state.isDelete) {
      this.props.getAllBusinessSubUsers();
      this.setState({ isDelete: false });
      this.setState({ data: settleRecord });
    }
    // console.log("settleRecord",settleRecord)
    // if(typeof settleRecord !== "undefined"){
    // this.setState({data: settleRecord.records});
    // }
  }

  componentDidUpdate() {
    const { GetBusinessSubUserList } = this.props.data;
    const { GetBusinessSubUserList1 } = this.state;

    // if(GetBusinessSubUserList1!==)
    if (GetBusinessSubUserList !== undefined) {
      if (GetBusinessSubUserList1 !== GetBusinessSubUserList) {
        this.setState({
          GetBusinessSubUserList1: GetBusinessSubUserList,
          data: GetBusinessSubUserList,
          loaded: false,
        });
      }
    }
  }

  deleteCompanyChild(id) {
    this.setState({ modalIsOpenSubUserDelete: true, deleteSubUserid: id });
  }

  closeModalSubUserDelete() {
    this.setState({ modalIsOpenSubUserDelete: false, deleteSubUserid: '' });
  }

  render() {
    const {
      data, loaded,
    } = this.state;
    let loader1;
    if (loaded) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    return (
      <span>
        {loader1}

        <Modal
          shouldCloseOnOverlayClick={false}
          isOpen={this.state.modalIsOpenSubUserDelete}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModalSubUserDelete}
          style={customStyles}
          contentLabel="test"
          ariaHideApp={false}
        >
          <div className="modal-content addvehicle-content">
            <div className="col s12 m7">
              <h4>Business Sub User</h4>
            </div>
            <div className="col s12">
              <div className="grey-box">
                <div className="grey-inner">
                  <p> Are you sure want to delete sub user ? </p>
                  <button
                    onClick={this.handleClickOpenDelete}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                      Yes
                    <i className="material-icons">arrow_forward</i>
                  </button>

                  <button
                    onClick={this.closeModalSubUserDelete}
                    style={{ marginLeft: '5px' }}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                      No
                    <i className="material-icons">arrow_forward</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <div className="section-content partner-dashboard partner-referral">
          <div className="row">
            <div className="col s12">
              <div className="">
                <div className="col s12">
                  <div className="col s12 referral-hdr">
                    <h4 className="col s12 m9">Manage Sub Users</h4>
                    <div className="col s12 m3 grid-add-link">
                      <Link to="/addSubUsersBusiness">
                        <button onClick={this.closeCompanyUserSub} type="submit" name="action" className="btn waves-effect waves-light primary-btn col s8 offset-s3 primary-btn-new sub-user-listing-button"> Add</button>
                      </Link>
                    </div>
                  </div>
                  {data.length !== 0 ? (
                    <div className="referral-data">
                      <div className="col s12">
                        <ReactTable
                          data={data}
                          columns={[
                            {
                              columns: [
                                {
                                  Header: 'First Name',
                                  accessor: 'firstName',
                                },
                                {
                                  Header: 'Last Name',
                                  id: 'lastName',
                                  accessor: d => d.lastName,
                                },
                                {
                                  Header: 'Email',
                                  id: 'email',
                                  accessor: d => d.email,
                                  filterable: false,
                                },
                                {
                                  Header: 'Phone',
                                  id: 'mobilePhone',
                                  accessor: d => d.mobilePhone,
                                },
                                {
                                  Header: 'Actions',
                                  id: 'link',
                                  filterable: false,
                                  accessor: d => d, // https://github.com/Michaelcj10/ReactJS-GitHub-User-Finder-App
                                  Cell: props => (
                                    <div>
                                      <Link
                                        className="font-medium show-right-button"
                                        to={`/businessSubUser/update/${
                                          props.value.businessSubUserId
                                        }`}
                                      >
                                        <i className="small material-icons">
                                        create
                                        </i>
                                      </Link>
                                      <a
                                        herf="#"
                                        onClick={() =>
                                          this.deleteCompanyChild(
                                            props.value.businessSubUserId,
                                          )
                                      }
                                      >
                                        <i className="small material-icons">
                                        delete_forever
                                        </i>
                                      </a>
                                    </div>
                                  ),
                                },
                              ],
                            },
                          ]}
                          defaultPageSize={10}
                          className="-striped -highlight"
                        />
                      </div>
                    </div>
                  )
                    : null}
                  <div className="col s12 sav-sub-user-buttons">
                    <Link to="/profile">
                      <button onClick={this.closeCompanyUserSub} type="submit" name="action" className="btn waves-effect waves-light primary-btn col s8 offset-s3 primary-btn-new"> Exit </button>
                    </Link>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

SubuserListAffiliate.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { submitSubUser, getAllBusinessSubUsers, deleteBusinessSubUser },
    dispatch,
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SubuserListAffiliate),
);
